// extracted by mini-css-extract-plugin
module.exports = {"heroPlaybackPlaceholder":"_3gFAbB"};